import {setCookie, storageAvailable, getCookie, cleanCookieName} from '../utilities/cookies'
import {waitLoad} from "../utilities/load";

var DEFAULT_OPTIONS = {
    occurence: 'eternity' //eternity, session, page
}

//changer popup pour message
//mettre les variables dans le css

export class BindMessage {
    constructor(name, options) {
        let that = this;
        options = Object.assign({}, DEFAULT_OPTIONS, options);
        let popups = document.querySelectorAll('.' + name + '-message');

        for (let i in popups) {
            if (!popups.hasOwnProperty(i))
                continue;
            let popup = popups[i],
                popupTimeout,
                popupOnTop;
            popupTimeout = (popup.matches('[data-' + name + '-timeout]')) ? parseInt(popup.getAttribute('data-' + name + '-timeout')) : 4000;

            popupOnTop = popup.matches('[data-' + name + '-top]');
            if (popupOnTop) {
                document.body.classList.add('will-have-' + name + '-message')
            }

            let closeBtns = document.querySelectorAll('.' + name + '-close');
            for (let x in closeBtns) {
                if(closeBtns[x] && closeBtns[x] instanceof Element || closeBtns[x] && closeBtns[x] instanceof HTMLDocument) {
                    var togglePopup = function (val, index) {
                        if(index)
                            popups[index].classList.toggle('visible', val);
                        else
                            popups[x].classList.toggle('visible', val);
                        if (popupOnTop) {
                            document.body.classList.toggle('has-' + name + '-message', val);
                        }
                        if(popups[index] && !popups[index].classList.contains('visible')) {
                            popups[index].remove();
                        }
                    }
                    var wasAccepted;
                    if (storageAvailable('localStorage'))
                        wasAccepted = that.getWithExpiry(name + closeBtns[x].getAttribute('data-id') + '-accepted');
                    else
                        wasAccepted = !!getCookie(cleanCookieName(name + closeBtns[x].getAttribute('data-id')));

                    if (!wasAccepted) {
                        togglePopup(true);
                    } else {
                        popups[x].remove();
                    }

                    let closeBtn = closeBtns[x];
                    closeBtn.addEventListener('click', function (e) {
                        togglePopup(false, x);
                        switch (options.occurence) {
                            case 'page':
                                break;
                            case 'session':
                                setCookie(cleanCookieName(name + closeBtn.getAttribute('data-id')), '1', 0);
                                break;
                            default:
                                if (storageAvailable('localStorage'))
                                    that.setLocalStorage(name + closeBtn.getAttribute('data-id') + '-accepted', '1');
                                else
                                    setCookie(cleanCookieName(name + closeBtn.getAttribute('data-id')), '1', 30)
                                break;
                        }
                    });
                }

            }
        }
        window.onresize = () => {
            this.adjustMarginTop();
        }
        this.adjustMarginTop();
    }

    adjustMarginTop(){
        const fromHome = document.querySelector('.home-banner');
        if(!fromHome) {
            let message = document.querySelectorAll('.alert-banner');
            let container = document.querySelector('.page-item--fixed');
            if(!container) {
                container = document.querySelector('main');
            }
            if(message && message.length > 0 && message[0].classList.contains('visible') && !document.body.classList.contains('menu-open')) {
                if(container){
                    document.querySelector('body').classList.add('has-alert-banner');
                    let y = message.length;
                    container.style.paddingTop = message[0].offsetHeight * y + 'px';
                    for(let x = 0; x < message.length; x++) {
                        message[x].querySelector('.alert-close').addEventListener('click', () => {
                            y--;
                            if(y === 0) {
                                document.querySelector('body').classList.remove('has-alert-banner');
                                container.style.paddingTop = "0px";
                            } else {
                                container.style.paddingTop = message[0].offsetHeight * y + 'px';
                            }
                        })
                    }
                }
            }
        }
    }
    setLocalStorage(key) {
        const now = new Date()
        const expiryTimerInMilliseconds = 2592000000;

        localStorage.setItem(key, JSON.stringify({value: key, expiry: now.getTime() + expiryTimerInMilliseconds}));
        this.getWithExpiry(key);
    }
    getWithExpiry(key) {
        const itemStr = localStorage.getItem(key)
        // if the item doesn't exist, return null
        if (!itemStr) {
            return null
        }

        const item = JSON.parse(itemStr)
        const now = new Date()

        if (now.getTime() > item.expiry) {
            localStorage.removeItem(key)
            return null
        }
        return item.value
    }
}
